export interface IPhotoArea {
  area: number;
  isMandatory: boolean;
  description: string;
  displayOrder: number;
}

export interface IPhotoAreaGridItem extends IPhotoArea {
  isRequired: boolean;
}

export enum PhotoArea {
  Front = 0,
  FrontTop = 7,
  FrontWindscreen = 8,
  FrontBumper = 9,

  Offside = 1,
  OffsideWingMirror = 10,
  OffsideFrontAlloyAndTyre = 11,
  OffsideRearAlloyAndTyre = 12,
  OffsideRearCorner = 13,

  Rear = 2,
  RearWindscreen = 14,
  RearTop = 15,
  RearBumper = 16,

  NearsideCorner = 17,
  Nearside = 3,
  NearsideWingMirror = 18,
  NearsideRearAlloyAndTyre = 19,
  NearsideFrontAlloyAndTyre = 20,
  NearsideFrontCorner = 21,

  Top = 4,

  InteriorFront = 22,
  InteriorRear = 23,
  Dashboard = 24,

  FuelGaugeAndOdometer = 5,
  Additional = 6,
}
